import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function Level10Illustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3619">
      <div className="relative w-full h-full bg-gradient-to-b from-orange-300 via-pink-300 to-purple-400 overflow-hidden" data-id="element-3620">
        {/* Background: Mountains and Sunset */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3621">
          {/* Sun */}
          <circle cx="100" cy="100" r="40" fill="#FEF08A" opacity="0.8" data-id="element-3622" />

          {/* Distant Mountains */}
          <path d="M-20 160 L40 90 L100 160 Z" fill="#94A3B8" opacity="0.6" data-id="element-3623" />
          <path d="M80 160 L150 80 L220 160 Z" fill="#94A3B8" opacity="0.5" data-id="element-3624" />

          {/* Main Mountain Peak */}
          <path d="M20 200 L100 100 L180 200 Z" fill="#64748B" data-id="element-3625" />
          {/* Snow cap */}
          <path d="M100 100 L80 125 L90 130 L100 120 L110 130 L120 125 Z" fill="#F8FAFC" data-id="element-3626" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3627">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3628">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} variant={variant} accessory="medal" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3629" />
          </div>
        </div>

        {/* Foreground: Clouds and Flag */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3630">
            {/* Flag planted on peak */}
            <path d="M130 100 L130 150" stroke="#475569" strokeWidth="3" strokeLinecap="round" data-id="element-3631" />
            <path d="M130 105 L160 115 L130 125 Z" fill="#EF4444" data-id="element-3632" />

            {/* Foreground clouds */}
            <path d="M-10 180 Q20 160 50 180 Q80 160 110 180 Q140 160 170 180 Q200 160 220 180 L220 200 L-10 200 Z" fill="#F1F5F9" opacity="0.8" data-id="element-3633" />
            <path d="M-10 190 Q30 175 70 190 Q110 175 150 190 Q190 175 220 190 L220 200 L-10 200 Z" fill="#E2E8F0" data-id="element-3634" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}